import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as taskService from '../../../services/task-service';
import {
    SEARCH_TASKS_REQUEST,
    SEARCH_TASKS_SUCCESS,
    SEARCH_TASKS_FAILURE,
    FETCH_TASK_REQUEST,
    FETCH_TASK_SUCCESS,
    FETCH_TASK_FAILURE,
    CREATE_TASK_REQUEST,
    CREATE_TASK_SUCCESS,
    CREATE_TASK_FAILURE,
    UPDATE_TASK_REQUEST,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_FAILURE,
    DELETE_TASK_REQUEST,
    DELETE_TASK_SUCCESS,
    DELETE_TASK_FAILURE
} from '../actions/task-actions';

function* searchTasksSaga(action) {
    try {
        const data = yield call(taskService.searchTasks, action.payload);
        yield put({ type: SEARCH_TASKS_SUCCESS, payload: data });
    } catch (error) {
        yield put({ type: SEARCH_TASKS_FAILURE, payload: error.message });
        toast.error('Failed to fetch tasks');
    }
}

function* fetchTaskSaga(action) {
    try {
        const data = yield call(taskService.fetchTaskById, action.payload);
        yield put({ type: FETCH_TASK_SUCCESS, payload: data });
    } catch (error) {
        yield put({ type: FETCH_TASK_FAILURE, payload: error.message });
        toast.error('Failed to fetch task');
    }
}

function* createTaskSaga(action) {
    try {
        const { boardId, data } = action.payload;
        const result = yield call(taskService.createTask, boardId, data);
        yield put({ type: CREATE_TASK_SUCCESS, payload: result });
        toast.success('Task created successfully');
    } catch (error) {
        yield put({ type: CREATE_TASK_FAILURE, payload: error.message });
        toast.error('Failed to create task');
    }
}

function* updateTaskSaga(action) {
    try {
        const { id, data } = action.payload;
        const result = yield call(taskService.updateTask, id, data);
        yield put({ type: UPDATE_TASK_SUCCESS, payload: result });
        toast.success('Task updated successfully');
    } catch (error) {
        yield put({ type: UPDATE_TASK_FAILURE, payload: error.message });
        toast.error('Failed to update task');
    }
}

function* deleteTaskSaga(action) {
    try {
        yield call(taskService.deleteTask, action.payload);
        yield put({ type: DELETE_TASK_SUCCESS, payload: action.payload });
        toast.success('Task deleted successfully');
    } catch (error) {
        yield put({ type: DELETE_TASK_FAILURE, payload: error.message });
        toast.error('Failed to delete task');
    }
}

export default function* taskSaga() {
    yield takeLatest(SEARCH_TASKS_REQUEST, searchTasksSaga);
    yield takeLatest(FETCH_TASK_REQUEST, fetchTaskSaga);
    yield takeLatest(CREATE_TASK_REQUEST, createTaskSaga);
    yield takeLatest(UPDATE_TASK_REQUEST, updateTaskSaga);
    yield takeLatest(DELETE_TASK_REQUEST, deleteTaskSaga);
}
